import { SinglePlanNotice } from "../single-plan/SinglePlanNotice";

/** Growth is the single plan: there is nothing to downgrade to. */
export function SettingsBillingDowngrade() {
  return <SinglePlanNotice />;
}
